/**
 * Build-time environment for the SPA bundle.
 *
 * CRA (react-scripts) only inlines variables prefixed `REACT_APP_` at build
 * time, so `scripts/build.js` re-exports Vercel's `VERCEL_TARGET_ENV` and
 * `VERCEL_GIT_COMMIT_SHA` under that prefix before `react-scripts build` runs.
 *
 * The default of `'production'` is deliberate: a plain `react-scripts build`,
 * `npm start`, or a jest run with nothing set behaves exactly like prod — the
 * UAT footer stamp stays off and pages keep `index, follow`. Only a build that
 * explicitly carries `REACT_APP_APP_ENV` (a Vercel custom environment, or the
 * local `REACT_APP_APP_ENV=uat npm run build` used to verify the stamp) flips
 * `IS_PROD` to false.
 */

/** The environment name: 'production' | 'uat' | 'preview' | 'development'. */
export const APP_ENV = process.env.REACT_APP_APP_ENV ?? 'production';

/**
 * Short (7-char) commit SHA for the footer build stamp. Empty when the build
 * wasn't run on Vercel (e.g. a local UAT build with no SHA exported).
 */
export const BUILD_SHA = (process.env.REACT_APP_BUILD_SHA ?? '').slice(0, 7);

/**
 * True only for the production environment. Everything else — UAT, Vercel
 * previews, local dev — is treated as non-prod (noindex, footer stamp shown).
 */
export const IS_PROD = APP_ENV === 'production';
